import { MediaRegistry } from './MediaRegistry';
import { VoiceoverRegistry } from './VoiceoverRegistry';

import type { StoredUploadedAssetData } from 'js/src/data/uploads/uploads-selectors';

/**
 * Resolves an uploaded audio or video asset that isn't in the Redux uploads slice — e.g. one
 * picked from the media library and rehydrated, which populates the registries but not
 * `state.uploads`. Tries the VoiceoverRegistry (audio) first, then the MediaRegistry (video),
 * and returns the same shapes `getUploadedAssetByUuid` yields so callers can treat
 * the two sources interchangeably.
 */
export async function resolveUploadedAssetFromRegistries(
    uuid: string,
): Promise<StoredUploadedAssetData | null> {
    const voiceoverRegistry = VoiceoverRegistry.getInstance();
    const voiceoverRegistryId = await voiceoverRegistry.addItemByUuid(uuid);
    const audioData = voiceoverRegistryId
        ? voiceoverRegistry.getAudioAsset(voiceoverRegistryId)
        : null;
    if (audioData) {
        return audioData;
    }

    const mediaRegistry = MediaRegistry.getInstance();
    const mediaRegistryId = await mediaRegistry.addItemByUuid(uuid);
    const background = mediaRegistryId ? mediaRegistry.getItem(mediaRegistryId)?.background : null;
    return background ?? null;
}
